import {put, call, cancel} from 'redux-saga/effects';
import Creators, {forgetPasswordFailed} from '../state/AppRedux';
import {settingService} from '../services/settingService';
import {validateFormErrorResponse} from '../helpers';
import {navigate} from 'gatsby';


// setting
export function* settingRequest(data) {
	yield put(Creators.fetching());
	console.log(data);
	let result = null;
	try {
		result = yield call(settingService.setting, data);
		console.log(result);
		if (result.data.response) {
			yield put(Creators.settingSuccessful(result.data.response));
		}
	} catch (e) {
		if (e.status === 401) {
			yield put(Creators.logout());
			navigate('/');
		}
		const validationMessages = validateFormErrorResponse(e.data.response);
		yield put(Creators.settingFailed(validationMessages));
	}
}
